import request from '@/utils/request'


// 查询商品门店库存列表
export function listGoodsStore(query) {
  return request({
    url: '/biz/admin/goods/store/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商品门店库存分页
export function pageGoodsStore(query) {
  return request({
    url: '/biz/admin/goods/store/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商品门店库存详细
export function getGoodsStore(data) {
  return request({
    url: '/biz/admin/goods/store/detail',
    method: 'get',
    params: data
  })
}

// 新增商品门店库存
export function addGoodsStore(data) {
  return request({
    url: '/biz/admin/goods/store/add',
    method: 'post',
    data: data
  })
}

// 修改商品门店库存
export function updateGoodsStore(data) {
  return request({
    url: '/biz/admin/goods/store/edit',
    method: 'post',
    data: data
  })
}

// 删除商品门店库存
export function delGoodsStore(data) {
  return request({
    url: '/biz/admin/goods/store/delete',
    method: 'post',
    data: data
  })
}


export function syncGoodsStore(data) {
  return request({
    url: '/biz/admin/goods/store/sync',
    method: 'post',
    data: data
  })
}


export function batchOn(data) {
  return request({
    url: '/biz/admin/goods/store/batchOn',
    method: 'post',
    data: data
  })
}


export function batchOff(data) {
  return request({
    url: '/biz/admin/goods/store/batchOff',
    method: 'post',
    data: data
  })
}

// 查询商品库存详细
export function getGoodsStock(data) {
  return request({
    url: '/biz/admin/goods/store/detail/stock',
    method: 'get',
    params: data
  })
}


export function updateGoodsStock(data) {
  return request({
    url: '/biz/admin/goods/store/edit/stock',
    method: 'post',
    data: data
  })
}
